import { MessageCircle, Phone, Mail } from "lucide-react";
import { buildWhatsAppUrl, buildCallUrl, buildEmailUrl } from "@commonqr/shared/utils/contactBar";

interface ContactActionButtonsProps {
  profile: {
    phone: string | null;
    email: string | null;
    whatsapp: string | null;
    contactGreeting?: string | null;
  };
  profileType: string;
  contactBar?: Array<"whatsapp" | "call" | "email">;
}

export function ContactActionButtons({ profile, profileType, contactBar = ["whatsapp", "call", "email"] }: ContactActionButtonsProps) {
  if (!profile.phone && !profile.email && !profile.whatsapp) return null;

  const wa = profile.whatsapp ?? profile.phone ?? "";
  const waUrl = wa ? buildWhatsAppUrl(wa, profileType, profile.contactGreeting) : null;
  const callUrl = profile.phone ? buildCallUrl(profile.phone) : null;
  const emailUrl = profile.email ? buildEmailUrl(profile.email, profileType, profile.contactGreeting) : null;

  const allButtons: Record<string, React.ReactNode> = {
    whatsapp: waUrl ? (
      <a key="whatsapp" href={waUrl} target="_blank" rel="noopener noreferrer"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 py-3 text-sm font-semibold text-white min-h-[44px]">
        <MessageCircle className="h-4 w-4" />
        WhatsApp
      </a>
    ) : null,
    call: callUrl ? (
      <a key="call" href={callUrl}
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-3 text-sm font-semibold text-white min-h-[44px]">
        <Phone className="h-4 w-4" />
        Call
      </a>
    ) : null,
    email: emailUrl ? (
      <a key="email" href={emailUrl}
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl bg-slate-600 px-4 py-3 text-sm font-semibold text-white min-h-[44px]">
        <Mail className="h-4 w-4" />
        Email
      </a>
    ) : null,
  };

  const ordered = contactBar.map(k => allButtons[k]).filter(Boolean);
  if (ordered.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 w-full mt-4">
      {ordered}
    </div>
  );
}